import { default as bloqueo_45ip3Ckdb9fccSMeta } from "/var/www/msn-form-inscripcion-web/pages/bloqueo-ip.vue?macro=true";
import { default as indexWOiEDphUDSMeta } from "/var/www/msn-form-inscripcion-web/pages/index.vue?macro=true";
export default [
  {
    name: "bloqueo-ip",
    path: "/bloqueo-ip",
    component: () => import("/var/www/msn-form-inscripcion-web/pages/bloqueo-ip.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/msn-form-inscripcion-web/pages/index.vue").then(m => m.default || m)
  }
]